import { clone } from '@/utils';
import * as creative_config from './creative';

/**
 * 获取创意表单配置
 * @param {string[]} keys 表单字段名称组成的数组
 * @returns {Object}
 */
export const getCreativeConfig = (keys = []) => {
  const config = clone(creative_config);
  for (const key in config) {
    if (config[key] && !(keys.includes(key))) {
      delete config[key];
    }
  }
  return config;
};
